<div class="preloader" *ngIf="isLoading">
    <img class="preloader__image" width="60" src="assets/imagens/fresh-apple-icon.svg" alt="img" />
</div>
